import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import CreateInvoiceContent from "./CreateInvoiceContent";
import CreatePayContent from "./CreatePayContent";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import "./EditInvoice.css";
import SideCanvas from "../Create-Contract/SideCanvas";
export default function EditInvoice() {

  const editorRef = useRef(null); 

  const childStateRef = useRef();
  const { invoiceId } = useParams();
  const [invoicetitle, setinvoicetitle] = useState("1");

  const [contractCount, setContractCount] = useState(1);

  const [contract, setContract] = useState(null);

  const [invoiceitem, setinvoiceitem] = useState(null);

  const [invoicepayments, setinvoicepayments] = useState([]);

  const [paidpayment, setpaidpayment] = useState(0);

  const [firstpayment, setfirstpayment] = useState(0);
  const [firstPaymentDueDate, setFirstPaymentDueDate] = useState("");
  const [invoicelength, setInvoicelength] = useState(0);
  const [editorInstances, setEditorInstances] = useState({});
  const [selectedValue1, setSelectedValue1] = useState("");

  const handlePaymentChange = (updatedPayments) => {
    if (updatedPayments && updatedPayments.length > 0) {
      const first = updatedPayments[0];
      setfirstpayment(first.amount ?? 0);
      setFirstPaymentDueDate(first.dueDate ?? "");
      setInvoicelength(updatedPayments.length);
    }
  };



  const title = useSelector((state) => state.title.title);

  const [tabs, setTabs] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const offcanvasRight = document.getElementById("offcanvasRight2");
    offcanvasRight.addEventListener("hidden.bs.offcanvas", () => {
      const invoiceTabButton = document.getElementById("v-pills-home-tab");
      invoiceTabButton.click();
    });
  }, []);


  // Options for the SunEditor instance – upload images to server, store URL in content (not base64)
  const addSmartTextPlugin = {
    name: "addSmartText",
    display: "command",
    title: "Add Smart Text",
    innerHTML: '<i class="fa fa-magic"></i>',
    buttonClass: "sun-editor-action customAction p-3",
    add: function () {},
    action: function () {
      const btn = document.getElementById("smarttextpopup");
      if (btn) btn.click();
    },
  };

  const editorOptions = {
    height: 200,
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
        "addSmartText",
      ],
    ],
    plugins: [...allPlugins, addSmartTextPlugin],
    ...getEditorUploadConfig(),
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };


  const getSunEditorInstance = (sunEditor, tabId) => {
    setEditorInstances((prev) => ({ ...prev, [tabId]: sunEditor }));
  };
  const handleSelectChange = (e) => {
    setSelectedValue1(e.target.value);
  };

  const handleInsertInputField = () => {
    const value = selectedValue1;
    if (!value) {
      Swal.fire({ icon: "warning", title: "Select a field", text: "Please choose a smart text field first!" });
      return;
    }
    try {
      const activeTabId = document.querySelector(".tab-pane.active")?.id;
      if (!activeTabId) return;
      const editor = editorInstances[activeTabId];
      if (editor) {
        editor.core.focus();
        editor.insertHTML(value);
      }
    } catch (err) {
      console.error("[SUNEDITOR.insertHTML.fail]", err);
    }
  };

  const handleEditorChange = (content, tabId) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.id === tabId ? { ...tab, content: content } : tab
      )
    );
  };


  useEffect(() => {
    // what should happen after the initial render
    const buttonid = `v-pills-${contractCount}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      activebutton.click();
    }
    //active.setAttribute("data-scroll", <your_value>)
  }, [tabs.length]);


  const totalpayment = () => {
    const Totalpayment = childStateRef.current.getTotalpayment();
    setpaidpayment(Totalpayment);
  }

  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      // const tabTitle = document.querySelector(`#${newTabId}-tab .box-title`);
      // tabTitle.textContent = newTitle;
      // alert("dhirendra");
      setTabs((prevTabs) =>
        prevTabs.map((tab) =>
          tab.id === tabId ? { ...tab, title: newTitle } : tab
        )
      );
    }
  }

  const handleClick = (id) => {
    setTabs(prevTabs => prevTabs.filter((item) => item.id !== id));
  };


  const handleAddContract = () => {



    const newTabId = `v-pills-${contractCount + 1}`;
    const buttonid = `v-pills-${contractCount + 1}-tab`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: `<div>
        <h1>${newTabTitle}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 1);
    document.getElementById('offcanvasRight2').classList.remove('show');
    document.getElementById("offcanvasRight2").style.visibility = "hidden";
  };


  const handleSubmit = async () => {
    const servicesstate = childStateRef.current.getMyservices();
    const PaymentsState = childStateRef.current.getPayments();


    const TaxperState = childStateRef.current.getTaxper();
    const TaxState = childStateRef.current.getTax();
    const DiscountperState = childStateRef.current.getDiscountper();
    const DiscountState = childStateRef.current.getDiscount();


    servicesstate.map((tab, i) => {
      if (tab.descp == '') {
        // updatedServices[index].errorprice="Required";
        var descerrro = document.getElementById('desc-' + i).parentElement;
        const small = descerrro.querySelector('small');
        small.innerText = 'Error:fill the fileds marked with *';

      }
      if (tab.type == '') {
        // updatedServices[index].errorprice="Required";
        var descerrro = document.getElementById('name-' + i).parentElement;
        const small = descerrro.querySelector('small');
        small.innerText = 'Error: fill the fileds marked with *';

      }

    });

    try {
      const response = await apiClient.put(`/invoice/${invoiceId}`, {
        title: title,
        user_id: JSON.parse(localStorage.getItem('user')).user.id,
        taxper: TaxperState,
        tax: TaxState,
        discountper: DiscountperState,
        discount: DiscountState,
        items: servicesstate,
        pages: tabs.map((tab) => ({
          ...tab,
          page_name: tab.title
        })),
        payments: PaymentsState,
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Invoice saved successfully!",
      });
      navigate("/invoices");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }

  };


  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await apiClient.get(`/invoice/${invoiceId}`);
        // setContractContent(response.data.pages[0].content);

        // setContract(response.data);
        // count=10;

        // setContractTitle(response.data.title);
        setinvoicetitle(response.data.title);



        response.data.invoice_page.forEach((tabs1, index) => {
          //count++;
          const newTabTitle = tabs1.page_name;


          const newTab = {
            id: `v-pills-${index}`,
            title: newTabTitle,
            content: tabs1.content
          };
          setTabs(tabs => [...tabs, newTab]);

          // Use functional update for setTabs to ensure latest state
        });


        setinvoiceitem(response.data.invoice_item);

        setinvoicepayments(response.data.invoice_payment);



        dispatch(setTitle(response.data.title));


        setContractCount(response.data.invoice_page.length + 1);

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchContract();
  }, []);

  return (
    <>
      {/* Side canvas for the smart text */}
      <SideCanvas />
      <div className='container-fluid p-lg-5 p-md-5 p-3'>
      <div className='row g-lg-5 row_mobile g-md-5 g-3 px-lg-5'>
        {/* Text Editor part */}
        <div className='col-md-9'>
          <div className='text-editor px-5 py-3 mobileview'>
            <div
              className='tab-content tab_content_invoice'
              id='v-pills-tabContent'>
              <div
                className='tab-pane fade show active'
                id='v-pills-home'
                role='tabpanel'
                aria-labelledby='v-pills-home-tab'
                tabIndex='0'>
                <CreateInvoiceContent ref={childStateRef} items={invoiceitem} invoicepayments={invoicepayments} onPaymentChange={handlePaymentChange} />
              </div>


              {tabs.map((tab) => (

                <div
                  key={tab.id}
                  className='tab-pane fade'
                  id={tab.id}
                  role="tabpanel"
                  aria-labelledby='v-pills-profile-tab'
                >
                  <div className="position-relative overflow-hidden">

                    <SunEditor
                      setOptions={editorOptions}
                      ref={editorRef}
                      defaultValue={tab.content}
                      onChange={(content) => handleEditorChange(content, tab.id)}
                      getSunEditorInstance={(instance) =>
                        getSunEditorInstance(instance, tab.id)
                      }
                    />
                  </div>
                </div>
              ))}


              <div
                className='tab-pane fade'
                id='v-pills-profile'
                role='tabpanel'
                aria-labelledby='v-pills-profile-tab'
                tabIndex='0'>
                <CreatePayContent
                  paidpayment={firstpayment}
                  duedate={firstPaymentDueDate}
                  invoicelength={invoicelength}
                />
              </div>



              <div
                className='tab-pane h-100 fade'
                id='v-pills-disabled'
                role='tabpanel'
                aria-labelledby='v-pills-disabled-tab'
                tabIndex='0'>
                <div className='add-page text-center d-flex flex-column justify-content-center align-items-center h-100'>
                  <h2>Add pages from your templates</h2>
                  <p>
                    Browse your templates to add pages <br /> or select “Start
                    from blank” to build a page from scratch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contract Right Area */}
        <div className='col-lg-3 col-md-8'>
          <span className='placeholder col-6'></span>

          <div className='row'>
            <div className='col-12'>
              <div className='right-side-area'>
                <div
                  className='nav flex-column nav-pills me-3'
                  id='v-pills-tab'
                  role='tablist'
                  aria-orientation='vertical'>
                  {/* Current Page Begin: Invoice Box */}
                  <button
                    className='nav-link active'
                    id='v-pills-home-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#v-pills-home'
                    type='button'
                    role='tab'
                    aria-controls='v-pills-home'
                    aria-selected='true'  >
                    {/* Current Page: Invoice Box */}
                    <div className='right-side-box'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center'>
                          <div
                            className='icon-box active bg-white'
                            role='button'>
                            {/* Skeletons */}
                            <div className='row gap-2 align-items-start m-2'>
                              <div className='col-12 skeleton-one'></div>
                              <div className='col-12 skeleton-two'></div>
                              <div className='col-12 skeleton-three'></div>
                              <div className='col-12 skeleton-four'></div>
                            </div>
                          </div>
                          <h5 className='box-title'>Invoice</h5>
                        </div>
                        {/* Dropdown */}
                        <div className='nav-item dropdown' id='top-user-nav'>

                          {/* Dropdown Menu */}

                        </div>
                      </div>
                    </div>
                  </button>
                  {/* Current Page End: Invoice Box */}

                  {tabs.map((tab) => (
                    <button
                      className='nav-link'
                      id={`${tab.id}-tab`}
                      data-bs-toggle='pill'
                      data-bs-target={`#${tab.id}`}
                      type='button'
                      role='tab'
                      aria-controls='v-pills-profile'
                      aria-selected='false'>
                      {/* Current Page: Pay Box */}
                      <div className='right-side-box'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className='d-flex align-items-center'>
                            <div
                              className='icon-box active bg-white'
                              role='button'>
                              {/* Skeletons */}
                              <div className='row gap-2 align-items-start m-2'>
                                <div className='col-12 skeleton-one'></div>
                                <div className='col-12 skeleton-two'></div>
                                <div className='col-12 skeleton-three'></div>
                                <div className='col-12 skeleton-four'></div>
                              </div>
                            </div>
                            <h5 className='box-title'>{tab.title}</h5>
                          </div>
                          {/* Dropdown */}
                          <div className='nav-item dropdown' id='top-user-nav'>
                            <div
                              href='#'
                              className='nav-link dropdown'
                              data-bs-toggle='dropdown'>
                              <div className='three-dot-btn'>
                                <button
                                  className='border-0 bg-transparent'
                                  type='button'>
                                  <i className='fa-solid fa-ellipsis-vertical'></i>
                                </button>
                              </div>
                            </div>
                            {/* Dropdown Menu */}
                            <div className='dropdown-menu shadow-sm border-0 py-4 px-4'>
                              <Link to='#'>
                                <div className='link-btn mb-4' data-tab={tab.id} onClick={() => renamepage(tab.id)}>
                                  <i
                                    className='fa fa-pencil'
                                    aria-hidden='true'></i>
                                  <span>Rename</span>
                                </div>
                              </Link>
                              <Link to='#'>
                                <div className='link-btn text-danger' data-tab={tab.id} onClick={() => handleClick(tab.id)} >
                                  <i className='fa-solid fa-trash'></i>
                                  <span>Delete</span>
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </button>


                  ))}







                  {/* Current Page begin: Pay Box */}
                  <button
                    className='nav-link'
                    id='v-pills-profile-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#v-pills-profile'
                    type='button'
                    role='tab'
                    aria-controls='v-pills-profile'
                    aria-selected='false' onClick={() => totalpayment()} >
                    {/* Current Page: Pay Box */}
                    <div className='right-side-box'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center'>
                          <div
                            className='icon-box active bg-white'
                            role='button'>
                            {/* Skeletons */}
                            <div className='row gap-2 align-items-start m-2'>
                              <div className='col-12 skeleton-one'></div>
                              <div className='col-12 skeleton-two'></div>
                              <div className='col-12 skeleton-three'></div>
                              <div className='col-12 skeleton-four'></div>
                            </div>
                          </div>
                          <h5 className='box-title'>Pay</h5>
                        </div>
                        {/* Dropdown */}
                        <div className='nav-item dropdown' id='top-user-nav'>
                          <div
                            href='#'
                            className='nav-link dropdown'
                            data-bs-toggle='dropdown'>
                            <div className='three-dot-btn'>

                            </div>
                          </div>
                          {/* Dropdown Menu */}

                        </div>
                      </div>
                    </div>
                  </button>
                  {/* Current Page end: Pay Box */}



                  {/* Add Page Start: New Page */}
                  <button
                    className='nav-link'
                    id='v-pills-disabled-tab'
                    data-bs-toggle='pill'
                    onClick={handleAddContract}
                    type='button'
                    role='tab'
                    aria-controls='v-pills-disabled'
                    aria-selected='false'>
                    {/* Add Page: New Page */}
                    <div className='right-side-box'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div
                          data-bs-toggle='offcanvas'
                          data-bs-target='#offcanvasRight2'
                          aria-controls='offcanvasRight2'
                          className='d-flex align-items-center'>
                          <div className='icon-box icon-box-add-page' role='button'>
                            <span>
                              <i className='fa-solid fa-plus'></i>
                            </span>
                          </div>
                          <h5 className='box-title'>Add Page</h5>
                        </div>
                        {/* Dropdown */}
                        <div
                          className='nav-item dropdown'
                          id='top-user-nav'
                          aria-disabled='true'>
                          <div
                            href='#'
                            className='nav-link dropdown'
                            data-bs-toggle='dropdown'></div>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>

                <div className='text-center pt-2'>
                  <button
                    id='submit-btn'
                    type='button'
                    className='px-5 rounded-pill btn btn-primary btn-lg text-uppercase'
                    onClick={handleSubmit}>
                    Save
                  </button>
                </div>


                {/* Add page canvas */}
                <div className='create-contract '>
                  <div
                    className='offcanvas offcanvas-end'
                    tabIndex='-1'
                    id='offcanvasRight2'
                    data-bs-scroll='true'
                    aria-labelledby='offcanvasRightLabel'
                    data-bs-backdrop='false'>
                    <div className='w-100 text-start header'>
                      <button
                        type='button'
                        className='btn-close mt-3 ms-4 text-black'
                        data-bs-dismiss='offcanvas'
                        aria-label='Close'></button>

                      <div className='text-center py-3'>
                        <h5>Add Page</h5>
                        <span style={{ color: "#727272" }}>
                          Select from the list below
                        </span>
                      </div>
                    </div>
                    <div className='w-100 text-start header'>
                      <div className='text-center py-3' onClick={handleAddContract}>
                        <span>+ Page With Text Only</span>
                      </div>
                    </div>

                    <div className='offcanvas-body p-0'>
                      <h5 className='px-4 py-2'>Contracts</h5>

                      <div className='single_box mt-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <h6>New Contract</h6>
                            <div className='d-flex align-items-center mt-1'>
                              <i className='far fa-folder'></i>
                              <span className='ms-2'>Contract</span>
                            </div>
                          </div>
                          <div className='icon'>
                            <i className='fa fa-chevron-right'></i>
                          </div>
                        </div>
                      </div>

                      <div className='single_box mt-4'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div>
                            <h6>Basic Booth Contract</h6>
                            <div className='d-flex align-items-center mt-1'>
                              <i className='far fa-folder'></i>
                              <span className='ms-2'>Contract</span>
                            </div>
                          </div>
                          <div className='icon'>
                            <i className='fa fa-chevron-right'></i>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h5 className='py-4 px-4'>Invoice</h5>
                        <div className='single_box mt-3'>
                          <div className='d-flex align-items-center justify-content-between'>
                            <div>
                              <h6>New Invoice</h6>
                              <div className='d-flex align-items-center mt-1'>
                                <i className='far fa-folder'></i>
                                <span className='ms-2'>Invoice</span>
                              </div>
                            </div>
                            <div className='icon'>
                              <i className='fa fa-chevron-right'></i>
                            </div>
                          </div>
                        </div>
                        <div className='single_box mt-4'>
                          <div className='d-flex align-items-center justify-content-between'>
                            <div>
                              <h6>Click Firefly - 2 Hour Invoice</h6>
                              <div className='d-flex align-items-center mt-1'>
                                <i className='far fa-folder'></i>
                                <span className='ms-2'>Invoice</span>
                              </div>
                            </div>
                            <div className='icon'>
                              <i className='fa fa-chevron-right'></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
      <div
        id="smarttextpopup"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRightSmartText"
        aria-controls="offcanvasRightSmartText"
        className="d-none"
      />
      {/* Smart Text canvas */}
      <div className="create-contract">
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasRightSmartText"
          aria-labelledby="offcanvasSmartTextLabel"
          data-bs-backdrop="false"
        >
          <div className="w-100 text-start header">
            <button
              type="button"
              className="btn-close mt-3 ms-4 text-black"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
            <div className="text-center py-3">
              <h5>Smart Text</h5>
            </div>
          </div>

          <div className="offcanvas-body p-4">
            <div className="single_box">
              <h6>Field content types: {selectedValue1}</h6>
              <select
                value={selectedValue1}
                onChange={handleSelectChange}
                style={{
                  width: "300px",
                  height: "40px",
                  outline: "none",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e8e4e4",
                }}
              >
                <option value="" disabled>
                  Select your option
                </option>
                <option value="{Event_Name}">Event Name</option>
                <option value="{First_Client_First_Name}">
                  First Client First Name
                </option>
                <option value="{First_Client_Last_Name}">
                  First Client Last Name
                </option>
                <option value="{First_Client_Email}">
                  First Client Email
                </option>
                <option value="{Event_Type}">Event Type</option>
              </select>
            </div>

            <div className="single_box mt-4">
              <button
                onClick={handleInsertInputField}
                style={{
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                  outline: "none",
                  backgroundColor: "#4f46e5",
                  border: "1px solid #e8e4e4",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Insert
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
